import type { Item, Sort, TableSchema } from './table'

import cx from 'classnames'

import { DownArrowIcon, UpArrowIcon } from '../../../assets/svgs/components'

import styles from './table-head.module.css'

interface Props<T extends Item> {
  schema: TableSchema<T>
  grid: string
  handleSortChange: (on: string) => void
  sort: Sort<T>
}

export function TableHead<T extends Item> ({ schema, grid, handleSortChange, sort }: Props<T>): JSX.Element {
  function handleClickSort (item: TableSchema<T>[0]): void {
    if ('name' in item) {
      let columnName = typeof item.sort === 'string' ? item.sort : item.name
      handleSortChange(columnName as string)
    }
  }

  return (
    <div
      className={styles.wrapper}
      style={{ gridTemplateColumns: grid }}
    >
      {schema.map((item) => {
        const hasName = 'name' in item

        let isSortable = hasName && (item.sort === true || typeof item.sort === 'string')
        let hasChevron = hasName && item.name === sort.on && item.sort
        let handleClick = isSortable ? () => handleClickSort(item) : undefined

        let Wrapper: keyof JSX.IntrinsicElements = isSortable ? 'button' : 'div'

        return (
          <Wrapper
            onClick={handleClick}
            key={item.label}
            className={cx(styles.header, {
              [styles.cursorPointer as string]: isSortable
            })}
            style={{
              textAlign: item.alignment
            }}
          >
            <span className={styles.label}>{item.label}</span>
            {hasChevron &&
              <div style={{ position: 'absolute', right: '-8px', top: 0 }}>
                {sort.dir === 'asc'
                  ? (
                    <DownArrowIcon
                      width='12px'
                      color='#000'
                    />
                  )
                  : (
                    <UpArrowIcon
                      width='12px'
                      color='#000'
                    />
                  )}
              </div>
            }
          </Wrapper>
        )
      })}
    </div>
  )
}
